import React, { useRef, useState } from "react";
import { useError } from "../context/ErrorContext";



interface DragAndDropProps {
  onFilesSelected: (files: File[]) => void;
  loading?: boolean;

}

const allowedExtensions = [".pdf", ".docx", ".msg",".xlsx",".xls"];

const DragAndDrop: React.FC<DragAndDropProps> = ({
  onFilesSelected, loading = false

}) => {
  const { showError, clearError } = useError();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  const isValidFile = (file: File) => {
    const ext = file.name.slice(file.name.lastIndexOf(".")).toLocaleLowerCase();
    return allowedExtensions.includes(ext);
  }


  const filterValidFiles = (files: File[]) => {
    const valid = files.filter(isValidFile);
    const invalid = files.filter(file => !isValidFile(file));

    if (invalid.length > 0) {
      showError("Only PDF, DOCX, XLSX|XLS, and MSG files are allowed!");
    } else if (valid.length > 0) {
      clearError();
    }

    return valid;
  }


  const onDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(true);
  };

  const onDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
  };

  const onDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    const validFiles = filterValidFiles(droppedFiles);

    if (validFiles.length > 0) {
      onFilesSelected(validFiles);
    }

  };


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files ? Array.from(e.target.files) : [];
    const validFiles = filterValidFiles(files);

    if (validFiles.length > 0) {
      onFilesSelected(validFiles)
    }
    e.target.value = ""; //reset input 
  };


  const handleDropZoneClick = () => {
    fileInputRef.current?.click();
  }



  return (
   <>
      <div
        data-testid="upload-dropzone"
        onDrop={onDrop}
        onDragOver={onDragEnter}
        onDragLeave={onDragLeave}
        className={` p-2 cursor-pointer  border-2 border-dashed border-gray-400 w-[450px]
                    rounded-xl text-center transition-all rounded-xl ${dragging ? "bg-blue-50 border-blue-500" : ""
          }`}
        onClick={handleDropZoneClick}
      >
      <div className="text-center">
        <svg
          className="w-24 h-24 mx-auto mb-4"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          fill="#00244f"
          stroke="#00244f"
          strokeWidth="0.00024"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <g>
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path
                fillRule="nonzero"
                d="M16 13l6.964 4.062-2.973.85 2.125 3.681-1.732 1-2.125-3.68-2.223 2.15L16 13zm-2-7h2v2h5a1 1 0 0 1 1 1v4h-2v-3H10v10h4v2H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6zM4 14v2H2v-2h2zm0-4v2H2v-2h2zm0-4v2H2V6h2zm0-4v2H2V2h2zm4 0v2H6V2h2zm4 0v2h-2V2h2zm4 0v2h-2V2h2z"
              ></path>
            </g>
          </g>
        </svg>
        <p className="text-gray-600">Browse or Drop File</p>
        <p className="text-sm text-gray-400">Allowed: .pdf, .docx, .msg, .xlsx | .xls</p>

      </div>
      </div>
      
      <div className="mt-4 flex justify-start ">
        <button 
          data-testid="upload-choose-files"
            onClick={handleDropZoneClick} 
            
            // className="p-2 bg-blue-600 text-white rounded shadow hover:bg-blue-700 text-sm
            className = {`px-4 py-2 rounded text-white rounded text-sm  transition ${ loading
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-blue-600 hover:bg-blue-700'
             }`}
            >
              Choose Files
            </button>
        <input
          data-testid="upload-file-input"
          
          type="file"
          ref={fileInputRef}
          multiple
          onChange={handleFileChange}
          hidden
          accept={allowedExtensions.join(",")}
        />

      </div>
      {/* {loading && (
          <div className="flex flex-col items-center space-y-2">
            <Spinner color="primary" />
            <p className="text-gray-600">Extracting metadata....</p>
          </div>
        ) } */}
</>
    
  );
};


export default DragAndDrop;
